"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputStyles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../form/constants");

var _constants2 = require("../form/input/constants");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var inputStyles = function inputStyles(_ref) {
  var error = _ref.error,
      props = _ref.props,
      selectors = _ref.selectors,
      warning = _ref.warning;
  var placeholderStyles = {
    color: selectors.color('neutral70'),
    fontStyle: 'italic'
  };
  var BORDER_COLOR = (0, _utils.getColor)(selectors, 'neutral50', error, warning);
  var BORDER_COLOR_FOCUS = (0, _utils.getColor)(selectors, 'primary80', error, warning);

  var styles = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    transition: 'border .2s, box-shadow .2s',
    boxSizing: 'border-box',
    margin: '0px',
    padding: _constants.INPUT_PADDING_DEFAULT,
    fontSize: selectors.fontSize('T200'),
    lineHeight: selectors.lineHeight('T200'),
    border: "".concat(_constants2.BORDER_WIDTH, "px solid ").concat(BORDER_COLOR),
    zIndex: 1,
    boxShadow: 'none',
    outline: 'none',
    ':focus': {
      borderColor: BORDER_COLOR_FOCUS,
      boxShadow: "0 0 0 1px ".concat(selectors.color('neutral0'), ", 0 0 0 3px ").concat(BORDER_COLOR_FOCUS),
      // Transparent outline needed to support Windows HC mode.
      outline: "".concat(_constants2.BORDER_WIDTH, "px solid transparent"),
      outlineOffset: '1px'
    },
    '::placeholder': placeholderStyles,
    '::-moz-placeholder': _objectSpread(_objectSpread({}, placeholderStyles), {}, {
      opacity: 1
    }),
    color: selectors.color('neutral90'),
    backgroundColor: selectors.color('neutral0')
  }, (0, _utils.cssValueProp)(selectors.fontWeight, props.fontWeight, 'fontWeight')), (0, _utils.cssValueProp)(selectors.fontFamily, props.font || 'primary', 'fontFamily')), (0, _utils.cssValueProp)(selectors.colorOrNull, props.color, 'color')), (0, _utils.cssValueProp)(selectors.colorOrNull, props.backgroundColor, 'backgroundColor'));

  return styles;
};

exports.inputStyles = inputStyles;